<template>
  <div class="background">
  <div id="app">
    <div id="nav">
    </div>
    <!--动画效果-->
    <transition :name="transitionName">
      <!--写上组件名称不刷新-->
      <keep-alive include="filterWords,filter3500">
        <router-view class="transitionBody"></router-view>
      </keep-alive>
    </transition>
  </div>
  </div>
</template>
<script>

import {Base64} from "js-base64";

export default {
  name: "app",
  data(){
    return {
      transitionName: 'slide-right',
    }
  },
  methods: {
    // 判断手机还是电脑
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    // 加载教材单词
    loadNewWords(){
      this.$store.state.loadingWords = true;
      try {
        const newWordsData = this.commonApi.readWordCache('newWords') ||
            this.commonApi.getInitialNewWords();
        this.$store.state.newWords = newWordsData.data;
        this.commonApi.writeWordCache('newWords', newWordsData);

        const words3500Data = this.commonApi.getCachedWords3500();
        this.$store.state.gaokaoWords = words3500Data.data;
        this.commonApi.writeWordCache('words3500', words3500Data);
      } catch(error) {
        console.error('内置词库加载失败', error);
      } finally {
        this.$store.state.loadingWords = false;
      }
    },
    // 判断localstorage数据
    getLocalStorage(){
      if(localStorage.getItem("newWords") == null || localStorage.getItem("words3500") == null){
          const words3500Data = new Promise( (resolve, reject) => {
            this.$store.state.loadingWords3500 = true;
            this.$store.state.loadingWords = true;
            const words3500Data = this.commonApi.getWords3500();
            resolve(words3500Data)
          });
        const newWordsData = words3500Data.then( words3500Data => {
          this.$store.state.loadingWords3500 = false;
          this.$store.state.gaokaoWords = words3500Data['data'];
          localStorage.setItem("words3500", Base64.encode(JSON.stringify(words3500Data)));
          console.log('words3500', words3500Data);
          const newWordsData = this.commonApi.getNewWords();
          return newWordsData
        });
        newWordsData.then( newWordsData => {
          this.$store.state.loadingWords = false;
          // localStorage.setItem("newWords", JSON.stringify(newWordsData));
          localStorage.setItem("newWords", Base64.encode(JSON.stringify(newWordsData)));
          this.$store.state.newWords = newWordsData['data'];
          console.log('newWords:', newWordsData);
        })
      }else{
        this.$store.state.newWords = JSON.parse(Base64.decode(localStorage.getItem("newWords")))['data'];
        this.$store.state.gaokaoWords = this.commonApi.getCachedWords3500()['data'];
        // this.$store.state.gaokaoWords = JSON.parse(localStorage.getItem("words3500"))['data'];
        console.log("localWords3500:", this.$store.state.gaokaoWords);
        console.log("localNewWords", this.$store.state.newWords);
      }
    },
    // 提前判断用户
    judgeUser(){
      function getYesterday(){
        const today = new Date()
        const yesterday = new Date(today)
        return yesterday.setDate(yesterday.getDate() - 1)
      }
      let tokenStr = window.localStorage.getItem('Authorization3500');

      // console.log('tokenStr', tokenStr)
      if(tokenStr == null){
        console.log('非3500用户')
        localStorage.removeItem("words3500");
        localStorage.removeItem("newWords");
      }else{
        let userString = decodeURIComponent(escape(window.atob(tokenStr.split('.')[1])))
        let tokenData = JSON.parse(userString);
        let username = tokenData['data'].username;
        // console.log('username:', tokenData['data'].username)
        let expDate = this.commonApi.getDate(tokenData['data']['exp']);

        // let expDate = getYesterday();
        let curDate = new Date();
        // console.log(expDate);
        if(expDate > curDate || username == 'xiegengzhe'){
          console.log('3500用户')
          let username = tokenData['data']['username'];
          this.$store.state.userShow = username.substr(0, 3);
          // console.log(this.$store.state.userShow)

        }else{
          console.log('过期用户')
          localStorage.removeItem("words3500");
          localStorage.removeItem("newWords");
          localStorage.removeItem('Authorization3500');
        }

      }

    },

  },
  watch:{
    $route(to, from) {
      const arr = ['/homepage', '/login', '/filter3500', '/synonymList', '/filterWords', '/wordsList', '/login_pc', '/homepage_pc']
      // 数组顺序index是判断顺序
      // console.log(arr)
      // console.log('from', arr.indexOf(from.path), from.path)
      // console.log('to', arr.indexOf(to.path), to.path)
      // this.transitionName = arr.indexOf(to.path) > arr.indexOf(from.path) ? 'transitionLeft' : 'transitionRight'
      this.transitionName = arr.indexOf(to.path) > arr.indexOf(from.path) ? 'slide-left' : 'slide-right'
    },
  },
  activated() {
  },
  created() {
    // Expire old snapshots before child pages read them, then rebuild from the APK.
    const curDate = new Date();
    const cachedDate = localStorage.getItem('Datewords3500');
    if (cachedDate) {
      try {
        const storeDate = new Date(Base64.decode(cachedDate));
        storeDate.setDate(storeDate.getDate() + 15);
        if (!Number.isFinite(storeDate.getTime()) || curDate > storeDate) {
          localStorage.removeItem('words3500');
          localStorage.removeItem('newWords');
          localStorage.removeItem('Datewords3500');
        }
      } catch(error) {
        localStorage.removeItem('Datewords3500');
      }
    }
    if (localStorage.getItem('Datewords3500') == null) {
      localStorage.setItem('Datewords3500', Base64.encode(curDate.toISOString()));
    }
  },
  mounted() {
    this.loadNewWords();   // 加载教材单词
    // this.judgeUser();
  },
}

</script>
<style>
html,
body,
#app,
.background {
  min-height: 100%;
}

html {
  background: #fff;
}

body {
  margin: 0;
  box-sizing: border-box;
  background: #fff;
}

.transitionBody {
  position: absolute;
  width: 100%;
  transition: all 0.4s ease;
}

.slide-left-enter{
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slide-right-leave-to,.slide-right-leave-active{
  display: none;
}
.slide-left-leave-active{
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
</style>
